import {
  StripeCardCvcElementChangeEvent,
  StripeCardExpiryElementChangeEvent,
  StripeCardNumberElementChangeEvent,
} from "@stripe/stripe-js"
import { Input } from "../formElements/input"
import { DateTime } from "luxon"
import React from "react"

export interface MockStripeElementProps {
  handleCardElementChange?: (
    e: StripeCardCvcElementChangeEvent | StripeCardNumberElementChangeEvent | StripeCardExpiryElementChangeEvent,
  ) => void
}
export enum MockValidationMessage {
  InvalidCard = "Your card number is invalid.",
  InvalidExpiry = "Your card's expiration year is in the past.",
  InvalidCvc = "Your card's security code is incomplete.",
}
export const testCardNumber = "4242424242424242"

export const MockCardNumberElement = (props: MockStripeElementProps) => {
  let stripeCardChangeEvent: StripeCardNumberElementChangeEvent | null = null
  const handleChange = (value: string) => {
    const trimed = value.trim()
    const isTestCard = trimed === testCardNumber
    stripeCardChangeEvent = {
      brand: isTestCard ? "visa" : "unknown",
      complete: isTestCard ? true : false,
      elementType: "cardNumber",
      empty: true,
      error: isTestCard
        ? { type: "validation_error", code: "200", message: "Your card number is invalid." }
        : undefined,
    }
    if (!!props.handleCardElementChange) {
      void props?.handleCardElementChange(stripeCardChangeEvent)
    }
  }
  return <Input name="mock-card-number" inputValue="" handleChange={(e) => handleChange(e.target.value)} />
}

export const MockCardExpiryElement = (props: MockStripeElementProps) => {
  let stripeCardChangeEvent: StripeCardExpiryElementChangeEvent | null = null
  const handleChange = (value: string) => {
    const trimed = value.trim()
    const validExpiry = DateTime.fromFormat(trimed, "LL/yy") > DateTime.local()
    stripeCardChangeEvent = {
      complete: validExpiry ? true : false,
      elementType: "cardExpiry",
      empty: true,
      error: validExpiry
        ? { type: "validation_error", code: "200", message: "our card's expiration year is in the past." }
        : undefined,
    }
    if (!!props.handleCardElementChange && !!stripeCardChangeEvent) {
      void props?.handleCardElementChange(stripeCardChangeEvent)
    }
  }
  return <Input name="mock-card-expiry" inputValue="" handleChange={(e) => handleChange(e.target.value)} />
}

export const MockCardCvcElement = (props: MockStripeElementProps) => {
  let stripeCardChangeEvent: StripeCardCvcElementChangeEvent | null = null
  const handleChange = (value: string) => {
    const trimed = value.trim()
    const validCvc = trimed.length >= 3 && trimed.length < 5
    stripeCardChangeEvent = {
      complete: validCvc ? true : false,
      elementType: "cardCvc",
      empty: true,
      error: validCvc
        ? { type: "validation_error", code: "200", message: "Your card's security code is incomplete." }
        : undefined,
    }
    if (!!props.handleCardElementChange && !!stripeCardChangeEvent) {
      void props?.handleCardElementChange(stripeCardChangeEvent)
    }
  }
  return <Input name="mock-card-cvc" inputValue="" handleChange={(e) => handleChange(e.target.value)} />
}

export const StripeElementOptions = {
  fonts: [
    {
      cssSrc: "https://fonts.googleapis.com/css?family=Lato",
    },
  ],
}
